import base from '../base';
import { getRequest, postJsonRequest } from '@/util/http';

const LOGIN = {
  // 获取省市区列表
  getAddressList(params) {
    return getRequest(`${base.baseUrl}/dictionary_gb_List`, params);
  },
  // 获取行业列表
  getIndustryList(params) {
    return getRequest(`${base.baseUrl}/dictionary_hy_List`, params);
  },
  // 用户登录
  userLogin(params) {
    return postJsonRequest(`${base.baseUrl}/user/login`, params);
  },
  // 用户注册
  userRegister(params) {
    return postJsonRequest(`${base.baseUrl}/user/register`, params);
  },
  // 用户注册
  userUpdatePwd(params) {
    return postJsonRequest(`${base.baseUrl}/user/update_password`, params);
  },
  // 校验账号是否注册过
  checkAccountRegistered(params) {
    return getRequest(`${base.baseUrl}/user/user_verify`, params);
  },
  // 手机短信验证码 - 获取
  getPhoneVerifyCode(params) {
    return postJsonRequest(`${base.baseUrl}/alisms_push`, params);
  },
  // 手机短信验证码 - 校验
  checkPhoneVerifyCode(params) {
    return postJsonRequest(`${base.baseUrl}/alisms_verify`, params);
  },
  // 邮箱验证码 - 获取
  getEmailVerifyCode(params) {
    return postJsonRequest(`${base.baseUrl}/email_push`, params);
  },
  // 邮箱验证码 - 校验
  checkEmailVerifyCode(params) {
    return postJsonRequest(`${base.baseUrl}/email_verify`, params);
  },
  // 图片验证码 - 获取
  getImageVerifyCode(params) {
    return postJsonRequest(`${base.baseUrl}/get_image`, params);
  },
  // 图片验证码 - 校验
  checkImageVerifyCode(params) {
    return postJsonRequest(`${base.baseUrl}/image_verify`, params);
  },
};

export default LOGIN;
